<script>
export default {
  name: 'TransactionPaymentInfo',
  props: {
    maskedCard: {
      type: Object,
      required: true
    },
    cartView: {
      type: Boolean
    }
  }
}
</script>

<template>
  <div
    id="transaction-payment-info"
    class="mb-4"
  >
    <h4 class="font-weight-bold mb-4">
      {{ $t ('header.paymentInformation') }}
    </h4>
    <h6 class="mb-3">
      {{ $t ('label.clickToPay') }}
    </h6>
    <div class="row">
      <div class="d-inline ml-3">
        <img
          :src="maskedCard.digitalCardData.artUri"
          alt="No Image"
          class="img-thumbnail card-logo"
        >
      </div>
      <div class="d-inline ml-3">
        <div
          v-if="maskedCard.panLastFour"
          class="text-break"
        >
          <label>
            {{ $t ('label.cardNumber') }}
          </label>
          <span
            id="card-number"
            data-test="card-number"
          >
            {{ maskedCard.panLastFour }}
          </span>
        </div>
        <div
          v-if="maskedCard.panExpirationYear || maskedCard.panExpirationMonth"
        >
          <label>
            {{ $t ('label.cardExpiration') }}
          </label>
          <span
            id="card-expiration"
            data-test="card-expiration"
          >
            {{ maskedCard.panExpirationMonth }}{{ maskedCard.panExpirationMonth ? '/' :
            '' }}{{ maskedCard.panExpirationYear }}
          </span>
        </div>
      </div>
    </div>
  </div>
</template>
